var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70611 0.271301C6.90204 0.452168 7 0.682361 7 0.961883C7 1.2414 6.90204 1.4716 6.70611 1.65247L2.53817 5.5L6.70611 9.34753C6.90204 9.5284 7 9.75859 7 10.0381C7 10.3176 6.90204 10.5478 6.70611 10.7287C6.51018 10.9096 6.26081 11 5.95802 11C5.65522 11 5.40585 10.9096 5.20992 10.7287L0.293894 6.19058C0.187024 6.09193 0.111146 5.98505 0.0662604 5.86996C0.0220874 5.75486 5.60652e-07 5.63154 5.49152e-07 5.5C5.37653e-07 5.36846 0.0220873 5.24514 0.0662603 5.13005C0.111146 5.01495 0.187024 4.90807 0.293894 4.80942L5.20992 0.271301C5.40585 0.0904343 5.65522 -7.50926e-07 5.95802 -7.77397e-07C6.26081 -8.03869e-07 6.51018 0.0904342 6.70611 0.271301Z",
    fill: "#056D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.e71b9ede292fe751d7887123ad3b8dbf.svg";
export { ForwardRef as ReactComponent };